export default "__VITE_ASSET__BDONXvRC__"